@if (isCeara) {
  <app-section-main-ceara id="main"></app-section-main-ceara>
  <app-section-proximo-confronto-ceara id="ingressos"></app-section-proximo-confronto-ceara>
  <app-section-planos-ceara id="planos"></app-section-planos-ceara>
  <app-section-carousel-beneficios-ceara id="beneficios"></app-section-carousel-beneficios-ceara>
  <app-section-tabela-beneficios id=""></app-section-tabela-beneficios>
  <app-section-banners id=""></app-section-banners>
  <app-section-conteudo-exclusivo-ceara id="exclusivo"></app-section-conteudo-exclusivo-ceara>
  <app-section-video id="video"></app-section-video>
  <app-section-ranking id="ranking"></app-section-ranking>
  <app-section-faq id="faq"></app-section-faq>
} @else {
  <app-section-main id="main"></app-section-main>
  <app-section-planos id="planos"></app-section-planos>
  <app-section-tabela-beneficios id=""></app-section-tabela-beneficios>
  <app-section-proximo-confronto id="ingressos"></app-section-proximo-confronto>
  <app-section-banners id=""></app-section-banners>
  <app-section-conteudo-exclusivo id="exclusivo"></app-section-conteudo-exclusivo>
  <!-- <app-section-simple-card id="marketing"></app-section-simple-card> -->
  <app-section-video id="video"></app-section-video>
  <app-section-carousel-beneficios id="beneficios"></app-section-carousel-beneficios>
  <app-section-ranking id="ranking"></app-section-ranking>
  <app-section-faq id="faq"></app-section-faq>
}


@if (enableWhatsappButton) {
  <a [href]="whatsappLink" class="whatsapp-float" target="_blank">
    <i class="fab fa-whatsapp fa-2x"></i>
  </a>
}